"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationListComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const translations_1 = require("@front/application/globals/translations");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const backendImport_1 = require("@front/backendImport");
const events_1 = require("@front/event/events");
const trans_1 = require("../../../../common/translations/trans");
//@ts-ignore                
let rwsTemplate = T.html `<div class="conversation-list${x => x.fullmode ? ' is-fullscreen' : ''}" @click="${(x, c) => x.closeDropdown()}">
    <div class="row mb-2 align-items-center">
        <div class="col-auto">
            <div class="chat-navigation">
                <div class="${x => x.fullmode ? 'fullmode' : 'dropdown'}">
                    ${(0, fast_element_1.when)(x => !x.fullmode, (0, fast_element_1.html) `<button class="btn btn-outline-secondary dropdown-toggle"
                        type="button" id="chatHistoryDropdown" aria-haspopup="true"
                        :aria-expanded="${x => x.dropdownOpen}" @click="${(x, c) => x.toggleDropdown(c.event)}">
                        <i class="iconsminds-speach-bubble-9 mr-2"></i>
                        ${x => x.selectedConversation ? x.selectedConversation.title : 'conversations.chat_history'.t()}
                    </button>`)}
                    <div class="dropdown-menu chat-history-dropdown ${x => x.dropdownOpen ? 'show' : ''}"
                        aria-labelledby="chatHistoryDropdown" @click="${(x, c) => x.handleDropdownClick(c.event)}">
                        <div class="dropdown-header">${'conversations.chat_history'.t()}</div>
                        <div class="search-container px-3 pb-2">
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control" :value="${x => x.searchQuery}"
                                    @input="${(x, c) => x.onSearchInput(c.event)}"
                                    placeholder="${'conversations.search_placeholder'.t()}" />
                            </div>
                        </div>
                        <div class="chat-history-list">
                            ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
                            <div class="dropdown-item-text text-center py-3">
                                <div class="loading-spinner spinner-border spinner-border-sm me-2"></div>
                                <span>${'conversations.loading'.t()}</span>
                            </div>
                            `)}

                            ${(0, fast_element_1.when)(x => x.error && !x.loading, (0, fast_element_1.html) `
                            <div class="dropdown-item-text text-center py-3">
                                <div class="text-danger mb-2">${x => x.error}</div>
                                <button class="btn btn-sm btn-outline-primary"
                                    @click="${x => x.loadConversations()}">${'conversations.retry'.t()}</button>
                            </div>
                            `)}

                            ${(0, fast_element_1.when)(x => !x.loading && !x.error && x.conversations.length === 0, (0, fast_element_1.html) `
                            <div class="dropdown-item-text text-muted text-center py-3">
                                ${'conversations.no_conversations_yet'.t()}
                            </div>
                            `)}

                            ${(0, fast_element_1.when)(x => !x.loading && !x.error && x.conversations.length > 0, (0, fast_element_1.html) `
                            ${(0, fast_element_1.repeat)(x => x.conversations, (0, fast_element_1.html) `
                            <a href="#"
                                class="chat-item dropdown-item ${(x, c) => c.parent.selectedconversationid === x.id ? 'active' : ''}"
                                type="button" data-chat-id="${x => x.id}"
                                @click="${(x, c) => c.parent.selectConversation(x, c.event)}">
                                <div class="chat-item-content">
                                    <div class="chat-title">${x => x.title}</div>
                                    <div class="chat-preview">${(x, c) => c.parent.lastMessage(x)}</div>
                                    <div class="chat-time">${(x, c) => c.parent.formatDate(x.lastActivity)}</div>
                                </div>
                                <div class="chat-actions">
                                    <div class="chat-action favorite-wrap">
                                        <rws-tooltip side="left" text="${x => x.favorite ? 'conversations.favorite.remove'.t() : 'conversations.favorite.add'.t()}">
                                            <button class="favorite-btn ${x => x.favorite ? 'is-favorite' : ''}"                                                
                                                @click="${(x, c) => c.parent.toggleFavorite(x, c.event)}">
                                                <app-star :full="${x => x.favorite}" width="15px"
                                                    height="15px"></app-star>
                                            </button>
                                        </rws-tooltip>
                                    </div>
                                    <div class="chat-action delete-wrap">
                                        <rws-tooltip side="left" text="${'conversations.delete.tooltip'.t()}">
                                            <button class="delete-btn" 
                                                @click="${(x, c) => c.parent.deleteConversation(x, c.event)}">
                                                <i class="simple-icon-close"></i>
                                            </button>
                                        </rws-tooltip>
                                    </div>
                                </div>
                            </a>
                            `)}
                            
                            ${(0, fast_element_1.when)(x => x.loadingMore, (0, fast_element_1.html) `
                            <div class="dropdown-item-text text-center py-2">
                                <div class="loading-spinner spinner-border spinner-border-sm me-2"></div>
                                <span>${'conversations.loading_more'.t()}</span>
                            </div>
                            `)}
                            
                            ${(0, fast_element_1.when)(x => !x.hasMorePages && x.conversations.length > 0 && !x.loadingMore, (0, fast_element_1.html) `
                            <div class="dropdown-item-text text-muted text-center py-2 small">
                                ${'conversations.no_more_conversations'.t()}
                            </div>
                            `)}
                            `)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-auto">
            <button class="btn btn-primary" id="newChatBtn" @click="${x => x.newConversation()}"
                :disabled="${x => x.loading}">
                <i class="simple-icon-plus"></i> ${'conversations.new_chat'.t()}
            </button>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.conversation-list {
  width: 100%;
}
.conversation-list .chat-navigation .dropdown-toggle {
  max-width: 250px;
  text-align: left;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.conversation-list .chat-navigation .dropdown-toggle .badge {
  font-size: 0.7rem;
}
.conversation-list .chat-navigation .chat-history-dropdown {
  min-width: 350px;
  max-height: 400px;
  overflow-y: auto;
  padding: 0;
}
.conversation-list .chat-navigation .chat-history-list {
  max-height: 300px;
  overflow-y: auto;
}
.conversation-list .chat-navigation .chat-item {
  padding: 0.75rem 1rem;
  border: none !important;
  background: none !important;
  width: 100%;
  text-align: left;
  transition: background-color 0.2s;
  cursor: pointer;
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  border-radius: 0 !important;
  position: relative;
}
.conversation-list .chat-navigation .chat-item:hover {
  background-color: #f8f9fa !important;
  text-decoration: none;
}
.conversation-list .chat-navigation .chat-item.active {
  background-color: #e3f2fd !important;
  border-left: 3px solid #007bff !important;
}
.conversation-list .chat-navigation .chat-item.active .chat-title {
  color: #007bff !important;
}
.conversation-list .chat-navigation .chat-item:focus {
  outline: none;
  box-shadow: none;
}
.conversation-list .chat-navigation .chat-item .chat-item-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  text-align: left;
}
.conversation-list .chat-navigation .chat-item .chat-item-content .chat-title {
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
  line-height: 1.2;
  text-align: left;
}
.conversation-list .chat-navigation .chat-item .chat-item-content .chat-preview {
  color: #6c757d;
  font-size: 0.8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
  text-align: left;
}
.conversation-list .chat-navigation .chat-item .chat-item-content .chat-time {
  color: #adb5bd;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  text-align: left;
}
.conversation-list .chat-navigation .chat-item .chat-actions {
  opacity: 0;
  transition: opacity 0.2s;
  margin-left: 0.5rem;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: 0.25rem;
}
.conversation-list .chat-navigation .chat-item .chat-actions.has-favorite {
  opacity: 1;
}
.conversation-list .chat-navigation .chat-item .chat-actions .favorite-btn {
  font-size: 0.75rem;
  background-color: transparent;
  border: none;
  padding: 0;
  line-height: 1;
  font-weight: bold;
  border-radius: 2px;
}
.conversation-list .chat-navigation .chat-item .chat-actions .delete-btn {
  font-size: 0.75rem;
  color: #dc3545;
  background-color: transparent;
  border: none;
}
.conversation-list .chat-navigation .chat-item:hover .chat-actions {
  opacity: 1;
}
.conversation-list .chat-navigation .fullmode .dropdown-menu {
  position: static !important;
  display: block !important;
  max-height: 100%;
  border: none;
}
.conversation-list .dropdown-menu.show {
  display: block;
}
.conversation-list #newChatBtn {
  white-space: nowrap;
}
.conversation-list #newChatBtn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.conversation-list.is-fullscreen {
  height: 100%;
}
.conversation-list.is-fullscreen > .row {
  flex-direction: column;
  gap: 15px;
  height: 100%;
}
.conversation-list.is-fullscreen .chat-navigation {
  height: 100%;
}
.conversation-list.is-fullscreen .chat-navigation .fullmode {
  height: 100%;
}
.conversation-list.is-fullscreen .chat-navigation .fullmode .chat-history-dropdown {
  height: 100%;
}
.conversation-list.is-fullscreen .chat-history-list {
  max-height: 100%;
  height: calc(100% - 37px);
}
.conversation-list.is-fullscreen .chat-history-list .loading-spinner {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.conversation-list.is-fullscreen .col-auto:nth-of-type(1) {
  order: 1;
  flex-shrink: 0;
  height: calc(100% - 40px - 15px);
}
.conversation-list.is-fullscreen .col-auto:nth-of-type(2) {
  order: 0;
  flex: 1;
  height: 40px;
}`;
const shadowOptions = { "mode": "open" };
let ConversationListComponent = class ConversationListComponent extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.conversations = [];
        this.loading = false;
        this.loadingMore = false;
        this.error = null;
        this.collapsed = false;
        this.searchQuery = '';
        this.searchTimeout = null;
        this.dropdownOpen = false;
        this.selectedConversation = null;
        this.selectedconversationid = null;
        this.fullmode = false;
        // Pagination state
        this.currentPage = 1;
        this.hasMorePages = true;
        this.totalCount = 0;
        this.perPage = 10;
    }
    async connectedCallback() {
        super.connectedCallback();
        // Note: conversation-list no longer auto-loads by default
        // Parent components should manually call loadConversations() when needed
        // Add document click listener to close dropdown when clicking outside
        document.addEventListener('click', this.handleDocumentClick.bind(this));
        // Add scroll listener for infinite scroll after template has rendered
        setTimeout(() => {
            this.setupScrollListener();
        }, 100);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Remove document click listener
        document.removeEventListener('click', this.handleDocumentClick.bind(this));
        // Remove scroll listener
        this.removeScrollListener();
    }
    selectedconversationidChanged(oldVal, newVal) {
        if (newVal && typeof newVal !== 'number') {
            this.selectedconversationid = Number(newVal);
        }
    }
    /**
     * Handle document clicks to close dropdown when clicking outside
     */
    handleDocumentClick(event) {
        const target = event.target;
        const dropdownElement = this.$('#chatHistoryDropdown');
        // If click is outside the dropdown, close it
        if (dropdownElement && !dropdownElement.contains(target) && !target.closest('.dropdown-menu')) {
            this.dropdownOpen = false;
        }
    }
    /**
     * Setup scroll listener for infinite scroll
     */
    setupScrollListener() {
        const chatHistoryList = this.$('.chat-history-list');
        if (chatHistoryList) {
            // Remove any existing listener first
            chatHistoryList.removeEventListener('scroll', this.handleScroll.bind(this));
            // Add the scroll listener
            chatHistoryList.addEventListener('scroll', this.handleScroll.bind(this));
        }
    }
    /**
     * Remove scroll listener
     */
    removeScrollListener() {
        const chatHistoryList = this.$('.chat-history-list');
        if (chatHistoryList) {
            chatHistoryList.removeEventListener('scroll', this.handleScroll.bind(this));
        }
    }
    /**
     * Handle scroll event for infinite scroll
     */
    handleScroll(event) {
        const target = event.target;
        const scrollTop = target.scrollTop;
        const scrollHeight = target.scrollHeight;
        const clientHeight = target.clientHeight;
        // Check if user has scrolled near the bottom (within 100px)
        const threshold = 100;
        const isNearBottom = scrollTop + clientHeight >= scrollHeight - threshold;
        console.log('[CONVERSATION-LIST] Scroll detected:', {
            scrollTop,
            scrollHeight,
            clientHeight,
            threshold,
            isNearBottom,
            hasMorePages: this.hasMorePages,
            loadingMore: this.loadingMore,
            loading: this.loading
        });
        if (isNearBottom && this.hasMorePages && !this.loadingMore && !this.loading) {
            console.log('[CONVERSATION-LIST] Triggering load more conversations');
            this.loadMoreConversations();
        }
    }
    /**
     * Load more conversations for infinite scroll
     */
    async loadMoreConversations() {
        await this.loadConversations(this.searchQuery, true);
    }
    async loadConversations(searchQuery, loadMore = false) {
        // Don't load more if already loading or no more pages
        if (loadMore && (this.loadingMore || !this.hasMorePages)) {
            return;
        }
        if (loadMore) {
            this.loadingMore = true;
        }
        else {
            this.loading = true;
            this.currentPage = 1;
            this.hasMorePages = true;
            this.conversations = [];
        }
        this.error = null;
        try {
            const queryParams = {
                per_page: this.perPage,
                p: loadMore ? this.currentPage + 1 : 1
            };
            if (searchQuery && searchQuery.trim()) {
                queryParams.q = searchQuery.trim();
            }
            const response = await this.apiService.back.get('conversation.list', {
                queryParams
            });
            if (response.success && response.data) {
                if (loadMore) {
                    // Append new conversations to existing list
                    this.conversations = [...this.conversations, ...response.data];
                    this.currentPage++;
                }
                else {
                    // Replace conversations for initial load or search
                    this.conversations = response.data;
                    this.currentPage = 1;
                }
                this.totalCount = response.count;
                // Check if there are more pages
                const totalLoaded = this.conversations.length;
                this.hasMorePages = totalLoaded < response.count;
            }
            else {
                this.error = response.error || 'Failed to load conversations';
            }
        }
        catch (error) {
            this.error = (0, trans_1.translate)('conversations.error.failedToLoad', (0, translations_1.getLanguage)() || 'en');
            console.error('Error loading conversations:', error);
        }
        finally {
            this.loading = false;
            this.loadingMore = false;
        }
    }
    toggleCollapse() {
        this.collapsed = !this.collapsed;
    }
    async selectConversation(conversation, event) {
        event.preventDefault();
        event.stopPropagation();
        this.selectedConversation = conversation;
        this.dropdownOpen = false; // Close dropdown using RWS observable
        const loadedConvo = await this.loadConversationMessages(conversation.id);
        // Dispatch custom event to notify parent component
        this.dispatchEvent(new CustomEvent('conversationSelected', {
            detail: { conversationId: conversation.id, conversation, messages: (loadedConvo === null || loadedConvo === void 0 ? void 0 : loadedConvo.frontMessages) || [] },
            bubbles: true
        }));
    }
    selectedConversationChanged(oldVal, newVal) {
        if (newVal) {
            if (!this.conversations.some(c => c.id === newVal.id)) {
                this.conversations = [newVal, ...this.conversations];
            }
            this.selectedconversationid = newVal.id || null;
        }
        else if (oldVal !== undefined && newVal === null) {
            this.selectedconversationid = null;
        }
    }
    formatDate(date) {
        const d = new Date(date);
        const now = new Date();
        const diffTime = Math.abs(now.getTime() - d.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays === 1) {
            return (0, trans_1.translate)('conversations.date.today', (0, translations_1.getLanguage)() || 'en');
        }
        else if (diffDays === 2) {
            return (0, trans_1.translate)('conversations.date.yesterday', (0, translations_1.getLanguage)() || 'en');
        }
        else if (diffDays <= 7) {
            return (0, trans_1.translate)('conversations.date.daysAgo', (0, translations_1.getLanguage)() || 'en').replace('{days}', (diffDays - 1).toString());
        }
        else {
            return d.toLocaleDateString();
        }
    }
    truncateMessage(message, maxLength = 50) {
        return message.length > maxLength ? message.substring(0, maxLength) + '...' : message;
    }
    /**
     * Strip HTML tags from message content
     */
    stripHtml(html) {
        var _a;
        if (!html)
            return '';
        // Create a temporary div element to parse HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        // Get text content and normalize whitespace
        return ((_a = tempDiv.textContent) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, ' ').trim()) || '';
    }
    async refreshConversations() {
        // Reset pagination when refreshing
        this.currentPage = 1;
        this.hasMorePages = true;
        await this.loadConversations(this.searchQuery, false);
    }
    onSearchInput(event) {
        const target = event.target;
        this.searchQuery = target.value;
        // Clear existing timeout
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        // Set new timeout for debounced search
        this.searchTimeout = window.setTimeout(() => {
            this.performSearch();
        }, 300); // 300ms debounce
    }
    async performSearch() {
        // Reset pagination when searching
        this.currentPage = 1;
        this.hasMorePages = true;
        await this.loadConversations(this.searchQuery, false);
    }
    clearSearch() {
        this.searchQuery = '';
        // Reset pagination when clearing search
        this.currentPage = 1;
        this.hasMorePages = true;
        this.loadConversations();
    }
    async deleteConversation(conversation, event) {
        var _a;
        event.preventDefault();
        event.stopPropagation(); // Prevent triggering selectConversation
        // Show confirmation dialog
        const confirmMessage = (0, trans_1.translate)('conversations.delete.confirm', (0, translations_1.getLanguage)() || 'en')
            .replace('{title}', conversation.title);
        if (!await this.popupService.confirm(confirmMessage)) {
            return;
        }
        try {
            const response = await this.apiService.back.delete(`conversation.delete`, { routeParams: { id: conversation.id } });
            if (response.success) {
                // Remove from local list
                this.conversations = this.conversations.filter(c => c.id !== conversation.id);
                // If this was the selected conversation, clear selection
                if (((_a = this.selectedConversation) === null || _a === void 0 ? void 0 : _a.id) === conversation.id) {
                    this.selectedConversation = null;
                    // Notify parent component
                    this.dispatchEvent(new CustomEvent('conversationDeleted', {
                        detail: { conversationId: conversation.id },
                        bubbles: true
                    }));
                }
                this.currentPage = 1;
                this.hasMorePages = true;
                this.loadConversations();
            }
            else {
                this.error = response.error || (0, trans_1.translate)('conversations.error.failedToDelete', (0, translations_1.getLanguage)() || 'en');
            }
        }
        catch (error) {
            this.error = (0, trans_1.translate)('conversations.error.failedToDelete', (0, translations_1.getLanguage)() || 'en');
            console.error('Error deleting conversation:', error);
        }
    }
    async toggleFavorite(conversation, event) {
        var _a;
        event.preventDefault();
        event.stopPropagation(); // Prevent triggering selectConversation
        try {
            const response = await this.apiService.back.post(`conversation.toggle-favorite`, null, { routeParams: { id: conversation.id } });
            if (response.success && response.data) {
                // Update the conversation in the local list
                const index = this.conversations.findIndex(c => c.id === conversation.id);
                if (index !== -1) {
                    this.conversations[index] = { ...this.conversations[index] };
                }
                // If this is the selected conversation, update it too
                if (((_a = this.selectedConversation) === null || _a === void 0 ? void 0 : _a.id) === conversation.id) {
                    this.selectedConversation = { ...this.selectedConversation };
                }
                // Reload conversations to get updated list order
                this.currentPage = 1;
                this.hasMorePages = true;
                this.loadConversations();
            }
            else {
                this.error = response.error || (0, trans_1.translate)('conversations.error.failedToToggleFavorite', (0, translations_1.getLanguage)() || 'en');
            }
        }
        catch (error) {
            this.error = (0, trans_1.translate)('conversations.error.failedToToggleFavorite', (0, translations_1.getLanguage)() || 'en');
            console.error('Error toggling favorite:', error);
        }
    }
    async loadConversationMessages(conversationId) {
        const response = await this.apiService.back.get('conversation.get-chat', { routeParams: { id: conversationId } });
        if (response.success && response.data) {
            this.$emit(events_1.appEvents.injectMessages, {
                messages: response.data.messages,
                conversation: response.data.conversation
            });
        }
        else {
            this.notifyService.alert((0, trans_1.translate)('conversations.error.failedToLoadMessages', (0, translations_1.getLanguage)() || 'en'));
        }
        return { conversation: response.data.conversation, frontMessages: response.data.messages };
    }
    newConversation() {
        this.selectedConversation = null;
        this.dropdownOpen = false; // Close dropdown when starting new conversation
        // Emit event to end current conversation but preserve avatar selection
        this.$emit(events_1.appEvents.frontChatConversationEnd);
    }
    /**
     * Toggle dropdown open/closed state
     */
    toggleDropdown(event) {
        event.preventDefault();
        event.stopPropagation();
        this.dropdownOpen = !this.dropdownOpen;
    }
    /**
     * Close dropdown when clicking outside
     */
    closeDropdown() {
        this.dropdownOpen = false;
    }
    /**
     * Handle clicks inside dropdown to prevent closing
     */
    handleDropdownClick(event) {
        event.stopPropagation();
    }
    lastMessage(conversation) {
        var _a;
        const lastMsg = conversation.lastMessage ? conversation.lastMessage : (((_a = conversation.messages) === null || _a === void 0 ? void 0 : _a.length) ? conversation.messages[conversation.messages.length - 1] : null);
        if (!lastMsg) {
            return 'conversations.no_messages_yet'.t();
        }
        // Strip HTML tags from the message content before truncating
        const cleanContent = this.stripHtml(lastMsg.content);
        return this.truncateMessage(this.sanitizeMarkdown(cleanContent));
    }
    sanitizeMarkdown(string) {
        if (!string)
            return '';
        let sanitized = string;
        // Convert code blocks ```LANG ``` to [CODE]
        sanitized = sanitized.replace(/```[\w]*\n?([\s\S]*?)```/g, `[${'app.intext.code'.t().toUpperCase()}]`);
        // Remove bold markdown (**text** and __text__)
        sanitized = sanitized.replace(/\*\*(.*?)\*\*/g, '$1');
        sanitized = sanitized.replace(/__(.*?)__/g, '$1');
        // Remove italic markdown (*text* and _text_)
        sanitized = sanitized.replace(/\*(.*?)\*/g, '$1');
        sanitized = sanitized.replace(/_(.*?)_/g, '$1');
        // Remove strikethrough (~~text~~)
        sanitized = sanitized.replace(/~~(.*?)~~/g, '$1');
        // Remove inline code (`text`)
        sanitized = sanitized.replace(/`(.*?)`/g, '$1');
        // Remove headers (# ## ### etc.)
        sanitized = sanitized.replace(/^#{1,6}\s+/gm, '');
        // Remove links but keep text [text](url) -> text
        sanitized = sanitized.replace(/\[([^\]]*)\]\([^)]*\)/g, '$1');
        // Clean up multiple spaces and normalize whitespace
        sanitized = sanitized.replace(/\s+/g, ' ').trim();
        return sanitized;
    }
};
exports.ConversationListComponent = ConversationListComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ConversationListComponent.prototype, "conversations", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ConversationListComponent.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ConversationListComponent.prototype, "loadingMore", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ConversationListComponent.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ConversationListComponent.prototype, "collapsed", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ConversationListComponent.prototype, "searchQuery", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ConversationListComponent.prototype, "searchTimeout", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ConversationListComponent.prototype, "dropdownOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IConversation !== "undefined" && backendImport_1.IConversation) === "function" ? _b : Object)
], ConversationListComponent.prototype, "selectedConversation", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Object)
], ConversationListComponent.prototype, "selectedconversationid", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], ConversationListComponent.prototype, "fullmode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ConversationListComponent.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ConversationListComponent.prototype, "hasMorePages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ConversationListComponent.prototype, "totalCount", void 0);
exports.ConversationListComponent = ConversationListComponent = __decorate([
    (0, client_1.RWSView)('conversation-list', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], ConversationListComponent);
ConversationListComponent.defineComponent();
